import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.inlines.outbound_call.label')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.inlines.outbound_call.disabled_label')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.inlines.inbound_call.label')
export const RadioLabel = ({ kind, isDisabled = false }) => (
  <BodyText size="medium">
    {isDisabled
      ? I18n.t(`publisher.event_type_editor.sections.event_details.location.inlines.${kind}.disabled_label`)
      : I18n.t(`publisher.event_type_editor.sections.event_details.location.inlines.${kind}.label`)}
  </BodyText>
)
